import React from 'react';
import PropTypes from 'prop-types';
import Dictionary from '../../../model/Dictionary';
import { Typography, withStyles } from 'material-ui';
import SelectedMealListItemStyles from './SelectedMealListItemStyles';

const NoSelectedMealItem = ({ passenger, className, classes }) => {
  const meals = passenger.meals;
  if (!meals || !meals.length || (meals.length === 1 && !meals[ 0 ].id)) {
    return [ 0, 1 ].map(item => (
      <Typography
        key={`passenger-${passenger.id}-${item}-no-selected-meal`}
        id={`passenger-${passenger.id}-${item}-no-selected-meal`}
        type='title'
        color='secondary'
        variant='button'
        className={`${classes.meal} ${className}`}
      >
        {item === 0 ? Dictionary.meal.select : <span>&nbsp;&nbsp;</span>}
      </Typography>
    ));
  }
  return null;
};

NoSelectedMealItem.propTypes = {
  passenger: PropTypes.object,
  className: PropTypes.string,
  classes: PropTypes.object,
};

export default withStyles(SelectedMealListItemStyles)(NoSelectedMealItem);



// WEBPACK FOOTER //
// ./src/components/meals/selectedMealListItem/NoSelectedMealItem.js